import { AnchorProps } from "@mantine/core";
import { flexidaoGreen } from "@flexidao/ui-lib/mantine-theme/colors/flexidao-colors";

export const anchorDefaultProps: Partial<AnchorProps> = {
    style: {
        color: flexidaoGreen[5],
    },
};
